import ApiClient from './ApiClient';

class ReservationPlansAPI extends ApiClient {
  constructor() {
    super('reservation_plans', { accountScoped: true });
  }
}

export default new ReservationPlansAPI();
